import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'hooks/apollo';
import { STATE_HISTORY_QUERY } from '../queries';
import FinancialProductStateHistoryModalComponent from './FinancialProductStateHistoryModalComponent.js';

const FinancialProductStateHistoryModalContainer = ({ productId, closeModal }) => {
  const { data } = useQuery(STATE_HISTORY_QUERY, {
    variables: { productId },
    skip: productId == null,
    fetchPolicy: 'network-only'
  });

  return <FinancialProductStateHistoryModalComponent stateTransitions={data?.financialProductStateHistory ?? []} closeModal={closeModal} />;
};

FinancialProductStateHistoryModalContainer.propTypes = {
  productId: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default FinancialProductStateHistoryModalContainer;
